export default [
    {
      path: '/good',
      component: () => import('@views/game'),
      children: (pre => [
        {
          path: pre+'/doll',
          component: () => import('@views/game/doll'),
          name: 'doll',
          meta: {
            isLogin: false,
            isFooterShow: false,
            title : '抓娃娃'
          }
        }
      ])('/good')
    }
  ]
  